import { IAccount } from "../../../common/accounts2";
import { $SiteColors } from "../../../common/config/company-atts";
import { kopecks2rubStr } from "../../../common/functions";

interface IKapRemontBalanceBlock {
  syncAcc: IAccount;
}

//отрисовываем данные о балансе капремонта
export const KapRemontBalanceBlock = ({ syncAcc }: IKapRemontBalanceBlock) => {
  let balance = kopecks2rubStr(syncAcc.balance);
  const numbersClassName =
    +balance >= 0
      ? "payment__text payment__text_green"
      : "payment__text payment__text_red";
  return (
    <div className="payment__container">
      <h4 className="payment__title">Капитальный ремонт:</h4>
      <div className="payment__numbers-button">
        <p className={numbersClassName}>{balance}</p>
        <button
          type="button"
          className="payment__button"
          style={{ backgroundColor: $SiteColors.getState().backBtnPayDebt }}
        >
          Оплатить
        </button>
      </div>
    </div>
  );
};
